(function () {
  let consentSent = false;
  let lastConsentSent = null;
  
  function sendConsentToShopify() {
    if (typeof Cookiebot === "undefined" || !Cookiebot.consent) {
      console.log("Cookiebot or consent not ready");
      return false;
    }
    
    if (!window.Shopify?.customerPrivacy?.setTrackingConsent) {
      console.warn("Shopify Customer Privacy API not ready");
      return false;
    }
    
    const consent = Cookiebot.consent;
    const consentToSend = {
      marketing: consent.marketing,
      analytics: consent.statistics,
    };
    
    // Prevent duplicates
    const consentKey = JSON.stringify(consentToSend);
    if (consentSent && lastConsentSent === consentKey) {
      console.log("Consent already sent, skipping:", consentToSend);
      return true;
    }
    
    try {
      window.Shopify.customerPrivacy.setTrackingConsent(consentToSend, () => {
        console.log("Consent sent to Shopify:", consentToSend);
        consentSent = true;
        lastConsentSent = consentKey;
      });
      return true;
    } catch (err) {
      console.error("Error setting consent:", err);
      return false;
    }
  }
  
  function initializeShopifyAPI() {
    if (!window.Shopify) {
      return;
    }
    
    window.Shopify.loadFeatures([{
      name: 'consent-tracking-api',
      version: '0.1',
    }], function (error) {
      if (error) {
        console.error("Failed to load Shopify consent API:", error);
        return;
      }
      if (typeof Cookiebot !== "undefined" && 
          Cookiebot.hasResponse === false && 
          Cookiebot.showBanner === false) {
        
        if (!consentSent) {
          window.Shopify.customerPrivacy.setTrackingConsent(
            { marketing: true, analytics: true },
            () => {
              console.log("Implicit consent granted (non-GDPR)");
              consentSent = true;
              lastConsentSent = JSON.stringify({ marketing: true, analytics: true });
            }
          );
        }
      } else {
        // GDPR region - try to send consent if available
        sendConsentToShopify();
      }
    });
  }
  
  let eventTimeout = null;
  function handleConsentEvent(eventName) {
    if (eventTimeout) clearTimeout(eventTimeout);
    
    eventTimeout = setTimeout(() => {
      sendConsentToShopify();
    }, 100); 
  }
  
  window.addEventListener("CookiebotOnConsentReady", () => handleConsentEvent("ConsentReady"));
  window.addEventListener("CookiebotOnAccept", () => handleConsentEvent("Accept"));
  window.addEventListener("CookiebotOnDecline", () => handleConsentEvent("Decline"));
  
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeShopifyAPI);
  } else {
    initializeShopifyAPI();
  }
})();